import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-2xl font-heading font-bold text-background-50 mb-4 block">
              韩漫屋
            </Link>
            <p className="text-sm text-secondary-300 leading-relaxed mb-4">
              {siteInfo.tagline}——{siteInfo.description.slice(0, 60)}...
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 text-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-primary-500 text-background-50 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">漫画分类</h4>
            <ul className="space-y-2">
              {categories.filter(c => c.slug !== 'all').slice(0, 6).map(cat => (
                <li key={cat.id}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">全部漫画</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-secondary-400 mt-0.5"></i>
                <span className="text-sm text-secondary-300">{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-secondary-400 mt-0.5"></i>
                <span className="text-sm text-secondary-300">{siteInfo.address}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-secondary-400 mt-0.5"></i>
                <span className="text-sm text-secondary-300">{siteInfo.phone}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-700">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} 韩漫屋 HanManWu.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-secondary-400 hover:text-secondary-200 transition-colors whitespace-nowrap">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}